import Banner from '../components/layout/Banner'
import About from './About'
import Experience from './Experience'
import Portfolio from './Portfolio'
import Contact from './Contact'

function Home() {
  return (
    <>
      <Banner />
      <About />
      <Experience />
      <Portfolio />
      <Contact />
    </>
  )
}

export default Home
